import DmsReserve from '../../../../components/editable-cell/form-items/dms-reserve'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import { hasTaskOfType } from '../../helpers/has-task-of-type'
import { isDurstMachine } from '../../../../helpers/is-durst-machine'
import { hasDmsInFinishing } from '../../../../helpers/is-dms-machine'

export const dmsReserveColumn: ShipmentColumn = {
    key: 'dmsReserve',
    dataIndex: 'dmsReserve',
    title: <RotatedTitle>Запас DMS</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <DmsReserve />,
    onCell: (record, index) =>
        ({
            ...onCellStandard(record, index),
            editable:
                isDurstMachine(record.machine) &&
                hasDmsInFinishing(record.additional_machines) &&
                !hasTaskOfType(record, 'Заказ форм'),
        }) as any,
}
